const css = `@charset "UTF-8";
.custom-bullet {
  list-style: none;
  margin-bottom: 0;
}

.custom-bullet li::before {
  content: "•";
  color: #fcd703;
  font-weight: bold;
  display: inline-block;
  width: 1em;
  margin-left: -1em;
}

.course-bullet {
  list-style: none;
  margin-bottom: 0;
}

.course-bullet li::before {
  content: "•";
  color: #fcd703;
  font-weight: bold;
  display: inline-block;
  width: 1em;
  margin-left: -4em;
}

.remove-bullet li::before {
  content: "•";
  color: white;
  margin-left: -5em;
}

.imported-courses-list {
  margin: 0;
  list-style: none;
}

.export-link {
  float: right;
  margin-top: 1em;
  text-decoration: underline;
}

.deactivatedDrawer {
  z-index: 1040;
}

.collapsible .ant-collapse-header-text {
  width: 100%;
}

.collapsible h5.ant-typography {
  margin-bottom: 0;
}

.collapsible .panelHeader {
  display: flex;
  align-items: center;
}

.errorsAndWarningTab .ant-tag-checkable {
  border: 1px solid #DFE2E2;
  border-radius: 12px;
  font-weight: 500;
  font-size: small;
  padding: 6px 8px;
  background: rgb(250, 250, 250);
}

.errorsAndWarningTab .ant-tag-checkable-checked {
  border: 1px solid #00427C;
  color: #00427C;
  background: #BAD7FF;
}

.searchInput .ant-input {
  max-width: 100%;
}

.viewLog .mainConfigSection:nth-of-type(1) .mainPerformTimeWrapper {
  padding-bottom: 10px;
}

.viewLog .mainConfigSection:nth-of-type(2) .mainPerformTimeWrapper {
  padding-top: 10px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2FwcC9hcHBzL2RhdGEtaW5nZXN0LXVpL3NyYy9hcHAvY29udGFpbmVycy9QU0RhdGFJbXBvcnRKb2JTdW1tYXJ5Iiwic291cmNlcyI6WyJzdHlsZXMuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7RUFDRTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTtFQUNBOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFIiwic291cmNlc0NvbnRlbnQiOlsiLmN1c3RvbS1idWxsZXQge1xuICBsaXN0LXN0eWxlOiBub25lO1xuICBtYXJnaW4tYm90dG9tOiAwO1xufVxuXG4uY3VzdG9tLWJ1bGxldCBsaTo6YmVmb3JlIHtcbiAgY29udGVudDogJ1xcMjAyMic7XG4gIGNvbG9yOiAjZmNkNzAzO1xuICBmb250LXdlaWdodDogYm9sZDtcbiAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICB3aWR0aDogMWVtO1xuICBtYXJnaW4tbGVmdDogLTFlbTtcbn1cblxuLmNvdXJzZS1idWxsZXQge1xuICBsaXN0LXN0eWxlOiBub25lO1xuICBtYXJnaW4tYm90dG9tOiAwO1xufVxuXG4uY291cnNlLWJ1bGxldCBsaTo6YmVmb3JlIHtcbiAgY29udGVudDogJ1xcMjAyMic7XG4gIGNvbG9yOiAjZmNkNzAzO1xuICBmb250LXdlaWdodDogYm9sZDtcbiAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICB3aWR0aDogMWVtO1xuICBtYXJnaW4tbGVmdDogLTRlbTtcbn1cblxuLnJlbW92ZS1idWxsZXQgbGk6OmJlZm9yZSB7XG4gIGNvbnRlbnQ6ICdcXDIwMjInO1xuICBjb2xvcjogd2hpdGU7XG4gIG1hcmdpbi1sZWZ0OiAtNWVtO1xufVxuXG4uaW1wb3J0ZWQtY291cnNlcy1saXN0IHtcbiAgbWFyZ2luOiAwO1xuICBsaXN0LXN0eWxlOiBub25lO1xufVxuXG4uZXhwb3J0LWxpbmsge1xuICBmbG9hdDogcmlnaHQ7XG4gIG1hcmdpbi10b3A6IDFlbTtcbiAgdGV4dC1kZWNvcmF0aW9uOiB1bmRlcmxpbmU7XG59XG5cbi5kZWFjdGl2YXRlZERyYXdlciB7XG4gIHotaW5kZXg6IDEwNDA7XG59XG5cbi5jb2xsYXBzaWJsZSAuYW50LWNvbGxhcHNlLWhlYWRlci10ZXh0IHtcbiAgd2lkdGg6IDEwMCU7XG59XG5cbi5jb2xsYXBzaWJsZSBoNS5hbnQtdHlwb2dyYXBoeSB7XG4gIG1hcmdpbi1ib3R0b206IDA7XG59XG5cbi5jb2xsYXBzaWJsZSAucGFuZWxIZWFkZXIge1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xufVxuXG4uZXJyb3JzQW5kV2FybmluZ1RhYiAuYW50LXRhZy1jaGVja2FibGUge1xuICBib3JkZXI6IDFweCBzb2xpZCAjREZFMkUyO1xuICBib3JkZXItcmFkaXVzOiAxMnB4O1xuICBmb250LXdlaWdodDogNTAwO1xuICBmb250LXNpemU6IHNtYWxsO1xuICBwYWRkaW5nOiA2cHggOHB4O1xuICBiYWNrZ3JvdW5kOiByZ2IoMjUwLCAyNTAsIDI1MCk7XG59XG5cbi5lcnJvcnNBbmRXYXJuaW5nVGFiIC5hbnQtdGFnLWNoZWNrYWJsZS1jaGVja2VkIHsgICAgXG4gIGJvcmRlcjogMXB4IHNvbGlkICMwMDQyN0M7XG4gIGNvbG9yOiAjMDA0MjdDO1xuICBiYWNrZ3JvdW5kOiAjQkFEN0ZGO1xufVxuXG4uc2VhcmNoSW5wdXQgLmFudC1pbnB1dCB7XG4gIG1heC13aWR0aDogMTAwJTtcbn1cblxuLnZpZXdMb2cgLm1haW5Db25maWdTZWN0aW9uOm50aC1vZi10eXBlKDEpIC5tYWluUGVyZm9ybVRpbWVXcmFwcGVyIHtcbiAgcGFkZGluZy1ib3R0b206IDEwcHg7XG59XG5cbi52aWV3TG9nIC5tYWluQ29uZmlnU2VjdGlvbjpudGgtb2YtdHlwZSgyKSAubWFpblBlcmZvcm1UaW1lV3JhcHBlciB7XG4gIHBhZGRpbmctdG9wOiAxMHB4O1xufVxuIl19 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
